<template>
  <div class="container-xxl">
    <template v-if="!auth.estaLogado()">
      <div class="col-md-10 col-lg-8 col-xl-6 col-xxl-4 offset-md-1 offset-lg-2 offset-xl-3 offset-xxl-4 py-3">
        <Titulo :sombra="false" titulo='Recuperação de senha' icon="" posicao="center" />
        <fieldset>
          <div class="alert alert-info text-center">
            Para sua segurança crie uma senha com pelo menos 8 dígitos, usando letras e números.
          </div>
          <form id="login" @submit.prevent="alterar_senha()">
            <InputText classDiv="col-12" tipo="password" :btn_lock="true" label="Nova senha *" tamanho="sm"
              nome="new_pass" ref="new_pass" :ativa_placeholder="load_dados" v-model="user.new_pass" />
            <InputText classDiv="col-12" tipo="password" :btn_lock="true" label="Repita Nova senha *" tamanho="sm"
              nome="renew_pass" ref="renew_pass" :ativa_placeholder="load_dados" v-model="user.renew_pass" />

            <div class="d-grid gap-2 mx-auto">
              <button type="submit" class="btn btn-info text-white btn-lg">
                Alterar senha
                <Spinner :visivel="false" id="load" />
              </button>
            </div>
          </form>
          <div class="row">
            <div class="col-6 col-md-4 d-grid gap-2 mx-auto">
              <a href="/#formulario" class="btn btn-light mt-2 btn-block">Cadastre-se</a>
            </div>
            <div class="col-6 col-md-4 d-grid gap-2 mx-auto">
              <router-link to="/login" class="btn btn-light mt-2 btn-block">Login</router-link>
            </div>
            <div class="col-6 col-md-4 d-grid gap-2 mx-auto">
              <router-link to="/recuperar_senha" class="btn btn-light mt-2 btn-block">Recuperar outro
                email</router-link>
            </div>
          </div>
        </fieldset>
      </div>
    </template>
    <template v-else>
      <div class="col-md-10 offset-md-1 py-3 mt-5">
        <boas-vindas :nome="auth.nomeUser" />
      </div>
    </template>
  </div>
</template>

<script>
import { bloqueia_campos, mensagem_request } from '@/assets/js/functions';
import InputText from '@/components/form/InputText.vue';
import Spinner from '@/components/Spinner.vue';
import Titulo from '@/components/Titulo.vue';
import { toastr } from '@/plugins/toast';
import { api } from '@/services/api';
import { AuthStore } from '@/stores/Auth';
import BoasVindas from '../components/login/BoasVindas.vue';

export default {
  name: 'AlterarSenha',
  data() {
    return {
      user: {
        verifica_email: localStorage.getItem('email'),
        codigo: localStorage.getItem('codigo'),
      },
      auth: AuthStore(),
      disable: false,
      verifica_envio: (localStorage.getItem('verifica_envio') ? localStorage.getItem('verifica_envio') : false)
    }
  },
  components: {
    InputText,
    Spinner,
    Titulo,
  },
  methods: {
    async alterar_senha() {
      if (!this.user.new_pass) {
        toastr.alerta("Digite uma nova senha")
        return false;
      } else
        if (this.user.new_pass.length < 8) {
          toastr.alerta("A nova senha deve ter pelo menos 8 caracteres")
          return false;
        }
      if (this.user.new_pass != this.user.renew_pass) {
        toastr.alerta("As senhas digitadas não conferem.")
        return false;
      }
      
      bloqueia_campos()
      try {
        const data = await api.post('login/alter_pass', this.user)

        mensagem_request(data)
        if (data.status == 200) {
          this.$router.push('login')
        }
      } catch (error) {
        toastr.erro("Erro ao fazer o login.");
      }
      bloqueia_campos(false)
    },
  },
  mounted() {
    if (this.user.verifica_email == null) {
      this.$router.push('recuperar_senha')
    }
    
    if(this.auth.estaLogado()){
      this.$router.push('login')
    }
  },
}
</script>

<style scoped></style>